import {Box, Flex, Image, HStack, Spacer, Text} from '@chakra-ui/react'

const Header = ({
  bgColor,
  children,
  showLogo,
  title,
  textStyle,
  align,
  color,
  p,
}) => {
  return (
    <Box>
      <Box bg={bgColor} color={color}>
        {showLogo ? (
          <Flex>
            <Box p={p}>
              <Image
                w="10rem"
                src="./Content/assets/HeaderLogo.svg"
                alt="Logo"
              />{' '}
            </Box>
            <Spacer />
            <Box m="auto" mr={10}>
              <Text textStyle={textStyle} color={color}>
                {' '}
                {title} {children}
              </Text>
            </Box>
          </Flex>
        ) : null}
      </Box>
      {!showLogo ? (
        <Box p={p} bg={bgColor}>
          <Text align={align} textStyle={textStyle} color={color}>
            {title}
            {children}
          </Text>
        </Box>
      ) : null}
    </Box>
  )
}

export default Header
